module.exports = __webpack_public_path__ + "img/icon-user-team.5e0abe55.svg";